/**
 * DOC-1/DOC-2 demo seed — parse jobs + results so the Shipment Auto-Builder
 * has realistic history on first load.
 *
 * All records are tenantId-stamped via seedLoader.
 */

const NOW = new Date('2026-04-18T12:00:00Z').toISOString();

export const SEED_DOC_PARSE_JOBS = [
  {
    id: 'pj_demo_riverside',
    userId: 'user-001',
    inputCount: 1,
    correlate: false,
    status: 'complete',
    createdAt: NOW,
    completedAt: NOW,
  },
  {
    id: 'pj_demo_keyston',
    userId: 'user-001',
    inputCount: 1,
    correlate: false,
    status: 'complete',
    createdAt: NOW,
    completedAt: NOW,
  },
  {
    id: 'pj_demo_scan',
    userId: 'user-001',
    inputCount: 1,
    correlate: false,
    status: 'complete',
    createdAt: NOW,
    completedAt: NOW,
  },
];

export const SEED_DOC_PARSE_RESULTS = [
  // Riverside NF — email tender, all high confidence
  {
    id: 'pr_demo_riverside_1',
    parseJobId: 'pj_demo_riverside',
    inputIndex: 0,
    type: 'email',
    filename: null,
    ok: true,
    documentType: 'EMAIL',
    fields: {
      customer: 'Riverside Natural Foods',
      shipper_name: 'Riverside Natural Foods',
      shipper_address: '890 Industrial Pkwy, Romeoville IL 60446',
      consignee_name: 'Whole Foods DC 2154',
      consignee_address: '4201 Centerpoint Dr, Austin TX 78758',
      origin_city: 'Romeoville', origin_state: 'IL',
      destination_city: 'Austin', destination_state: 'TX',
      weight_lbs: 38200, pieces: null, pallets: 24,
      commodity: 'Organic almond butter (FAK)',
      freight_class: 70,
      mode: 'FTL',
      pickup_date: '2026-04-19', pickup_window: '08:00-10:00',
      delivery_date: '2026-04-22', delivery_window: '13:00-15:00',
      reference_number: 'RVN-44928',
      special_instructions: 'Reefer 34°F continuous; lift gate at delivery.',
    },
    confidencePerField: {
      customer: 97, shipper_address: 92, consignee_address: 94,
      origin_city: 98, origin_state: 98, destination_city: 96, destination_state: 98,
      weight_lbs: 95, pallets: 92, commodity: 90, freight_class: 88, mode: 96,
      pickup_date: 97, delivery_date: 94, reference_number: 98,
    },
    sourceSnippet: 'From: Sarah Patel <sarah@riversidenaturalfoods.com>\nSubject: Tender — RVN-44928 — Romeoville IL to Austin TX…',
    provider: 'seed',
    createdAt: NOW,
  },

  // Keyston Bros — scanned PDF BOL, mixed confidence
  {
    id: 'pr_demo_keyston_1',
    parseJobId: 'pj_demo_keyston',
    inputIndex: 0,
    type: 'scanned_pdf',
    filename: 'KB-BOL-90214.pdf',
    ok: true,
    documentType: 'BOL',
    fields: {
      customer: 'Keyston Bros',
      shipper_name: 'Keyston Bros — Dallas DC',
      shipper_address: '2100 Stemmons Fwy, Dallas TX 75212',
      consignee_name: 'Phoenix Flooring Supply',
      consignee_address: '3415 W Van Buren St, Phoenix AZ 85009',
      origin_city: 'Dallas', origin_state: 'TX',
      destination_city: 'Phoenix', destination_state: 'AZ',
      weight_lbs: 12400, pieces: 480, pallets: 8,
      commodity: 'Prefinished oak flooring 3/4 x 5"',
      freight_class: 70,
      mode: 'LTL',
      pickup_date: '2026-04-20', pickup_window: null,
      delivery_date: '2026-04-23', delivery_window: null,
      reference_number: 'KB-90214',
      bol_number: '90214-BOL',
      po_number: 'PHX-00912',
    },
    confidencePerField: {
      customer: 93, shipper_address: 88, consignee_address: 78,
      origin_city: 95, origin_state: 97, destination_city: 92, destination_state: 95,
      weight_lbs: 91, pieces: 66, pallets: 74, commodity: 85, freight_class: 72, mode: 95,
      pickup_date: 80, delivery_date: 64, reference_number: 95, bol_number: 98, po_number: 86,
    },
    sourceSnippet: 'BILL OF LADING · Keyston Bros · Dallas → Phoenix · PRO …',
    provider: 'seed',
    createdAt: NOW,
  },

  // Scanned warehouse BOL — one red-confidence field, requires rep confirm
  {
    id: 'pr_demo_scan_1',
    parseJobId: 'pj_demo_scan',
    inputIndex: 0,
    type: 'image',
    filename: 'photo-bol.jpg',
    ok: true,
    documentType: 'BOL',
    fields: {
      customer: 'Gulf Coast Distribution',
      shipper_name: 'Gulf Coast Distribution',
      shipper_address: '4120 Airport Blvd, Mobile AL 36608',
      consignee_name: 'Southern Grocer',
      consignee_address: 'Atlanta GA',
      origin_city: 'Mobile', origin_state: 'AL',
      destination_city: 'Atlanta', destination_state: 'GA',
      weight_lbs: 28400,
      commodity: 'Mixed groceries',
      freight_class: 85,
      mode: 'Reefer',
      pickup_date: '2026-04-19',
      delivery_date: null,
      reference_number: 'GCD-55120',
    },
    confidencePerField: {
      customer: 82, shipper_address: 71, consignee_address: 52, // red
      origin_city: 92, origin_state: 95, destination_city: 86, destination_state: 94,
      weight_lbs: 58, // red
      commodity: 68, freight_class: 80, mode: 90,
      pickup_date: 76, reference_number: 81,
    },
    sourceSnippet: 'BILL OF LADING (photo) — Gulf Coast Distribution · Mobile AL → Atlanta GA …',
    provider: 'seed',
    createdAt: NOW,
  },
];

export const SEED_DOC_FEEDBACK = [];
